/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realitymix_TitleInputs */

const cs_realitymix_title = /** @type {(inputs: Realitymix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealityMIX`)
};

const en_realitymix_title = /** @type {(inputs: Realitymix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealityMIX`)
};

/**
* | output |
* | --- |
* | "RealityMIX" |
*
* @param {Realitymix_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const realitymix_title = /** @type {((inputs?: Realitymix_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realitymix_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realitymix_title(inputs)
	return cs_realitymix_title(inputs)
});